window.TV2 = window.TV2 || {};
/**
 * Initialize videolist
 * @param list
 * @constructor
 */
window.TV2.VideoList = (list, imageAssetPath, playImageService) => {
  const id = list.id;
  const query = list.query;
  const size = list.size;
  const sort = list.sort;
  let start = list.start;
  const view = list.view;

  const listContainer = document.getElementById(`tv2_contentbox_videolist-${id}`);
  const loadMore = listContainer.querySelector('.videolist__seemore');

  function checkButton(assets) {
    if (!assets.asset || assets.asset.length === undefined || assets.asset.length < size) {
      loadMore.style.display = 'none';
    }
  }

  const getImage = (asset) => {
    let img = null;
    if (asset.imageUrl) {
      img = `http://www.tv2.no/tvid/${asset.imageUrl}`;
    }
    if (asset.metadata && asset.metadata.sumoImagePackId) {
      img = `${playImageService}/${asset.metadata.sumoImagePackId.$}?width=306&height=200`;
    }
    return img;
  };
  const getViews = (views) => {
    if (!views) {
      return null;
    }
    if (parseInt(views, 10) > 1000) {
      return parseInt(views / 1000, 10) + 'K';
    }
    return views;
  };

  function renderAsset(asset) {
    const assetId = asset['@id'];
    const img = getImage(asset);
    const duration = window.TV2.getReadableDuration(asset.duration);
    const title = asset.title;
    // eslint-disable-next-line no-unused-vars
    const views = {
      nice: getViews(asset.views),
      real: asset.views,
    };

    const article = document.createElement('article');

    article.classList.add('video-article', `large-${view.gridSpan}`, 'small-6');

    article.innerHTML = `
      <a class="video-article__link" itemprop="url" href="${view.assetUrl}${assetId}">
      <figure class="image image__responsive ${img ? '' : 'image__placeholder'}">
        <div class="article__video">
          <div class="article__video--play">
            <svg><use xlink:href="#icon-play"></use></svg>
          </div>
        </div>
        ${
          img
            ? `<img class="image__img lazyload" itemprop="image" alt="" data-src="${img}">`
            : `<img src="${imageAssetPath}/logo/tv2-logo-white.svg" alt="TV 2 Logo">`
        }
        </figure>
        <div class="video-article__text">
          <div itemprop="headline" class="article__title video-article__title ${
            view.textSize
          } tm24">
            ${title}
            <div class="video-article__meta">
              <div class="video-article__duration">
                <span class="video-article__icon">
                  <svg><use xlink:href="#icon-time" /></svg>
                </span>
                ${duration}
              </div>
            </div>
          </div>
        </div>
      </a>`;

    return article;
  }

  function renderResult(assets) {
    const targetContainer = listContainer.querySelector('.row');
    if (assets.asset.length) {
      assets.asset.forEach((asset) => {
        targetContainer.appendChild(renderAsset(asset));
      });
    } else {
      targetContainer.appendChild(renderAsset(assets.asset));
    }
  }

  function fetchAssets() {
    const url = `https://play.tv2.no/api/web/search/categories/666/assets.json?query=${query}&size=${size}&sort=${sort}&start=${start++}`;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        const assets = data.assets;
        if (assets && assets.asset) {
          checkButton(assets);
          renderResult(assets);
        }
      });
  }

  if (loadMore) {
    loadMore.addEventListener('click', (e) => {
      e.preventDefault();
      fetchAssets();
    });
  }
};
